<ng-container
  *ngFor="let modal of modals | async | keyvalue; trackBy: trackModal"
>
  <div class="modal-container" @fade>
    <ng-container *ngTemplateOutlet="modal.value"></ng-container>
  </div>
</ng-container>
